import * as types from '../types/couponTypes';
import * as couponServices from '../../services/couponServices';

export function fetchCoupons(params = {}) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_COUPONS_REQUEST });
    try {
      const data = await couponServices.fetchCoupons(params);
      const list = Array.isArray(data) ? data : (data.coupons || data || []);
      dispatch({ type: types.FETCH_COUPONS_SUCCESS, payload: list });
    } catch (error) {
      dispatch({ type: types.FETCH_COUPONS_FAILURE, payload: error.message });
    }
  };
}

export function fetchCouponById(id) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_COUPON_BY_ID_REQUEST });
    try {
      const data = await couponServices.getCouponById(id);
      dispatch({ type: types.FETCH_COUPON_BY_ID_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.FETCH_COUPON_BY_ID_FAILURE, payload: error.message });
    }
  };
}

export function createCoupon(payload) {
  return async (dispatch) => {
    dispatch({ type: types.CREATE_COUPON_REQUEST });
    try {
      const data = await couponServices.createCoupon(payload);
      dispatch({ type: types.CREATE_COUPON_SUCCESS, payload: data });
      return { success: true, data };
    } catch (error) {
      dispatch({ type: types.CREATE_COUPON_FAILURE, payload: error.message });
      return { success: false, error: error.message };
    }
  };
}

export function updateCoupon(id, payload) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_COUPON_REQUEST });
    try {
      const data = await couponServices.updateCoupon(id, payload);
      dispatch({ type: types.UPDATE_COUPON_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.UPDATE_COUPON_FAILURE, payload: error.message });
    }
  };
}

export function deleteCoupon(id) {
  return async (dispatch) => {
    dispatch({ type: types.DELETE_COUPON_REQUEST });
    try {
      await couponServices.deleteCoupon(id);
      dispatch({ type: types.DELETE_COUPON_SUCCESS, payload: id });
    } catch (error) {
      dispatch({ type: types.DELETE_COUPON_FAILURE, payload: error.message });
    }
  };
}

